import React from "react";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from "react-router-dom";

const Workitem = ({ work }) => {
  return (
    <Link className="projectLink" to={`/project/${work.id}`}>
    <div className="project">
      <img className="projectImage" src={work.thumbnail} alt={work.title} />
      <h4 className="projectTitle">{work.title}</h4>
      <p className="projectDesc">
        {work.description.length > 30
          ? `${work.description.substring(0, 30)}...`
          : work.description}
      </p>
      <span className="projectLink">
      View Details <AiOutlineArrowRight className="proIcon" />
    </span>
      {/* <Link className="projectLink" to={`/project/${work.id}`}>
        View Details <AiOutlineArrowRight className="proIcon" />
      </Link> */}
    </div>
    </Link>
  );
};
  
export default Workitem;






// import React from "react";
// import { AiOutlineArrowRight } from "react-icons/ai";
// import { Link } from "react-router-dom";

// const Workitem = ({ work }) => {
//   return (
//     <div className="project">
//       <img className="projectImage" src={work.thumbnail} alt={work.title} />
//       <h4 className="projectTitle">{work.title}</h4>
//       <p className="projectDesc">
//         {work.description.length > 30
//           ? `${work.description.substring(0, 30)}...`
//           : work.description}
//       </p>
//       <Link className="projectLink" to={`/project/${work.id}`}>
//         View Details <AiOutlineArrowRight className="proIcon" />
//       </Link>
//     </div>
//   );
// };

// export default Workitem;
